export const EXODUS_ASSET_NAME_TO_CHAIN_NATIVE_TOKEN_NAME = {
    'arbitrum-one': 'arbitrum',
    avalanchec: 'avalanche',
    basemainnet: 'base',
    bitcoin: 'bitcoin',
    bitcoinregtest: 'bitcoin',
    bitcointestnet: 'bitcoin',
    bsc: 'binance-coin',
    ethereum: 'ether',
    ethereumarbone: 'arbitrum',
    ethereumarbonesepolia: 'arbitrum',
    ethereumholesky: 'ether',
    evm0x144: 'zksync',
    evm0x343b: 'immutable',
    evm0x504: 'moonbeam',
    evm0x52415249: 'rari',
    evm0xa4ec: 'celo',
    evm0xec0: 'astar',
    evm0xff: 'kroma',
    evm0xaa36a7: 'ether',
    mantle: 'mantle',
    mantlesepolia: 'mantle',
    matic: 'polygon',
    optimism: 'optimism',
    polygon: 'polygon',
    solana: 'solana',
    solanadevnet: 'solana',
    solanatestnet: 'solana',
};
